var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0762 19C10.1222 19 8.46684 18.3223 7.11017 16.967C5.75417 15.611 5.07617 13.9563 5.07617 12.003C5.07617 10.0497 5.75417 8.39433 7.11017 7.037C8.46684 5.679 10.1222 5 12.0762 5C13.2648 5 14.3775 5.28233 15.4142 5.847C16.4515 6.41167 17.2875 7.2 17.9222 8.212V5H18.9222V10.23H13.6922V9.23H17.3922C16.8715 8.23333 16.1388 7.44567 15.1942 6.867C14.2508 6.289 13.2115 6 12.0762 6C10.4095 6 8.99284 6.58333 7.82617 7.75C6.65951 8.91667 6.07617 10.3333 6.07617 12C6.07617 13.6667 6.65951 15.0833 7.82617 16.25C8.99284 17.4167 10.4095 18 12.0762 18C13.3595 18 14.5178 17.6333 15.5512 16.9C16.5845 16.1667 17.3095 15.2 17.7262 14H18.7872C18.3465 15.4973 17.5088 16.705 16.2742 17.623C15.0395 18.541 13.6402 19 12.0762 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshicon);
export default __webpack_public_path__ + "static/media/refreshicon.466101c23c201eb589bf1fe621a21ce8.svg";
export { ForwardRef as ReactComponent };